var _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEmotionlimit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1505,
    cy: 8.71792,
    r: 4.61538,
    fill: "#606A96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99609 20.5127C6.99609 17.1141 9.75127 14.3589 13.1499 14.3589C16.5486 14.3589 19.3038 17.1141 19.3038 20.5127V27.6922H6.99609V20.5127Z",
    fill: "#606A96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99609 27.6924H12.1243V34.8719C12.1243 35.4383 11.6651 35.8975 11.0987 35.8975H8.02174C7.45529 35.8975 6.99609 35.4383 6.99609 34.8719V27.6924Z",
    fill: "#92A0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1758 27.6924H19.304V34.8719C19.304 35.4383 18.8448 35.8975 18.2783 35.8975H15.2014C14.635 35.8975 14.1758 35.4383 14.1758 34.8719V27.6924Z",
    fill: "#92A0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8459 15.7829C25.4307 14.654 23.365 14.746 22.0558 16.0587C20.6481 17.4702 20.6481 19.7588 22.0558 21.1704L26.2998 25.4257C26.6146 25.7414 27.1538 25.5184 27.1538 25.0727V16.4721C27.1538 16.2073 27.0528 15.948 26.8459 15.7829Z",
    fill: "#FFAFBF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3084 15.7829C30.7236 14.654 32.7893 14.746 34.0985 16.0587C35.5062 17.4702 35.5062 19.7588 34.0985 21.1704L29.8545 25.4257C29.5397 25.7414 29.0005 25.5184 29.0005 25.0727V16.4721C29.0005 16.2073 29.1015 15.948 29.3084 15.7829Z",
    fill: "#FFAFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmotionlimit);
export default __webpack_public_path__ + "static/media/ic_emotionlimit.0a6a353a5e2ce2f0de7df72341a407bc.svg";
export { ForwardRef as ReactComponent };